import React from 'react'
import styled from 'styled-components'
import { textStyles } from '@zuto/theme/src/zuto/typography'
import { VehicleDetailsDataObject } from '../../services/vehicle-service'
import { numberWithCommas } from '../Questions/utils'
import { Box } from '@mui/material'

const MediaQueryBox = styled(Box)`
  ${textStyles.body.smallPrint.medium};
  @media (min-width: 435px) {
    ${textStyles.body.current.medium}
  }
`
interface VehicleInfoProps {
  vehicle: VehicleDetailsDataObject;
}

const VehicleInfo = ({ vehicle }: VehicleInfoProps): JSX.Element => (
  <>
    <MediaQueryBox data-testid="vehicle-make-model">
      {vehicle.make} {vehicle.model}
    </MediaQueryBox>
    <MediaQueryBox data-testid="vehicle-price">
      £{vehicle.price ? numberWithCommas(vehicle.price) : 0}
    </MediaQueryBox>
    <MediaQueryBox data-testid="vehicle-details">
      {vehicle.registrationYear && `${vehicle.registrationYear} | `}
      {vehicle.transmission && ` ${vehicle.transmission} |`}
      {vehicle.fuelType && ` ${vehicle.fuelType}`}
    </MediaQueryBox>
  </>
)

export default VehicleInfo
